import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Typography, Grid, makeStyles } from '@material-ui/core';
import { Rating } from '@material-ui/lab'
import { ButtonActions, ButtonActionsWhite } from 'Components/UI';
import { formattingDigitCurrency } from 'utils/FormattingDigit';
import { Link, useHistory } from 'react-router-dom';
import { staticDataAtom } from 'Atoms/Common';

const useStyles = makeStyles((theme) => ({
  root: theme.containerGrid
}));

const Voting = ({_rate, saveRate, name}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [rate, setRate] = useState(_rate);

  return (
    <Grid
      container
      className={classes.root}
      justifyContent="center"
      alignContent="center"
      alignItems="center"
    >
      <Grid item xs={11}>
      <Rating
          name={name}
          value={rate}
          onChange={(event, newValue) => {
              saveRate(newValue);
              setRate(newValue);
          }}
      />
      </Grid>
    </Grid>
  );
};

Voting.propTypes = {};

export default Voting;
